import { EditDateTime } from '~/routes';
import { envConfigSelectors } from '~/selectors';
import { withComponentDecisioner } from '~/hocs/with-component-decisioner';
import { EditDate } from '~/routes/edit';

const componentDecisioner = [
  {
    supports: envConfigSelectors.selectIsNewCalendarEnabled,
    component: EditDateTime,
  },
];

export const config = {
  editMode: {
    editDateComponent: withComponentDecisioner(() => componentDecisioner)(EditDate),
  },
};
